export default "__VITE_PUBLIC_ASSET__0891b152__"